import useTargetPeriodFormatter from '../../../../../../../../target/hooks/useTargetPeriodFormatter';
import { TARGET_CRITERION_TYPE_LABEL } from '../../../../../../../../target/object/TargetObjectPage/targetObjectLabels.constants';
import { TargetPaths } from '../../../../../../../../target/target.paths';
import {
  getCriterionValues,
  getDimensionName,
  sortDimensions,
} from '../../../../../../../../target/targetDetail.utils';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';
import { OrderTargetSummary } from '../../../orderObjectTargetsTab.types';
import { OrderTargetSummaryView } from '../orderTargetSummaryTooltip.types';

const VALUES_SEPARATOR = ', ';

const useOrderTargetSummary = (
  summary: OrderTargetSummary | undefined,
): OrderTargetSummaryView | undefined => {
  const { translate } = useTranslation();
  const { formatPeriod } = useTargetPeriodFormatter();

  if (!summary) {
    return undefined;
  }

  const criteria = summary.criteria.map((criterion) => ({
    criterion: translate(TARGET_CRITERION_TYPE_LABEL[criterion.type]),
    values: getCriterionValues({ criterion, translate }).join(VALUES_SEPARATOR),
  }));

  const dimensions = sortDimensions(summary.dimensions).map((dimension) =>
    getDimensionName({ dimension, translate }),
  );

  return {
    code: summary.code,
    name: summary.name,
    period: formatPeriod(summary.period),
    criteria,
    dimensions,
    href: TargetPaths.detail(summary.id),
  };
};

export default useOrderTargetSummary;
